import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
});

/**
 * MySpaceMyCardsCreateEvent
 *
 * - Evento emitido quando um card é criado e deve ser adicionado ao meu espaço.
 */
export class MySpaceMyCardsCreateEvent extends CreateCommand(RealtimeEventType.MySpaceMyCardsCreate, SCHEMA) {}
